// extracted by mini-css-extract-plugin
export default {"cta":"tM-z","disabled":"uM-z"};